import { SVGProps } from 'react'

import { cn } from '@/shared/lib'

import { ILLUST, type IllustName } from './illust'

type Props = SVGProps<SVGSVGElement> & {
  name: IllustName
  size?: number | string
  active?: boolean
}

export const Illust = ({
  name,
  size = '100%',
  active = false,
  className,
  ...restProps
}: Props) => {
  const IllustComponent = ILLUST[name]

  return (
    <IllustComponent
      width={size}
      height={size}
      className={cn(
        'shrink-0',
        active ? 'text-purple-500' : 'text-gray-200',
        className,
      )}
      {...restProps}
    />
  )
}
